import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {Button} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {PairwiseItemX} from '../../evaluation-criteria-x.types';
import {CriteriaRankingRowX} from './criteria-ranking-x.types';

@Component({
  selector: 'app-criteria-ranking-x',
  imports: [Button, TooltipModule, TranslocoPipe, TranslateDirectusPipe],
  templateUrl: './criteria-ranking-x.component.html',
  styles: [
    `
      :host ::ng-deep .p-button.ranking-move-button {
        width: 2.25rem !important;
        height: 2.25rem !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CriteriaRankingXComponent {
  readonly translationKeyPrefix = input.required<string>();
  readonly testId = input.required<string>();
  readonly rankedItems = input<PairwiseItemX[]>([]);
  readonly disabled = input(false);

  readonly rankingChanged = output<PairwiseItemX[]>();

  protected readonly hintKey = computed<string>(
    () => `${this.translationKeyPrefix()}.ranking.hint`,
  );

  protected readonly moveUpKey = computed<string>(
    () => `${this.translationKeyPrefix()}.ranking.moveUp`,
  );

  protected readonly moveDownKey = computed<string>(
    () => `${this.translationKeyPrefix()}.ranking.moveDown`,
  );

  protected readonly rows = computed<CriteriaRankingRowX[]>(() => {
    const disabled = this.disabled();
    const items = this.rankedItems();

    return items.map((item, index) => ({
      item,
      position: index + 1,
      movesUpDisabled: disabled || index === 0,
      movesDownDisabled: disabled || index === items.length - 1,
    }));
  });

  moveUp(index: number): void {
    this.emitSwapped(index, index - 1);
  }

  moveDown(index: number): void {
    this.emitSwapped(index, index + 1);
  }

  private emitSwapped(index: number, targetIndex: number): void {
    const items = this.rankedItems();
    if (this.disabled() || targetIndex < 0 || targetIndex >= items.length) {
      return;
    }

    const reordered = [...items];
    reordered[index] = items[targetIndex];
    reordered[targetIndex] = items[index];
    this.rankingChanged.emit(reordered);
  }
}
